import React, { forwardRef } from 'react';
import { cn } from './cn';

export const Textarea = forwardRef(function Textarea(
  { invalid, rows = 4, className, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={cn(
        'w-full resize-y bg-surface text-body-sm text-fg placeholder:text-fg-subtle',
        'border rounded-md px-3 py-2',
        'transition-[border-color,box-shadow] duration-150 ease-out-soft',
        'focus-visible:outline-none focus-visible:border-brand-500 focus-visible:shadow-focus-ring',
        'disabled:cursor-not-allowed disabled:bg-ink-50 dark:disabled:bg-ink-800 disabled:text-fg-subtle',
        invalid
          ? 'border-danger-500 focus-visible:border-danger-500 focus-visible:shadow-focus-ring-danger'
          : 'border-line',
        className,
      )}
      {...rest}
    />
  );
});

export default Textarea;
